'use strict';
angular.module('cakeapp')

.constant('serverSettings', angular.extend({
    analyticsReportingEnabled: false,
}, window.serverSettings));
